import React from 'react';

// Common helper function to handle trademark symbols in names
export const formatNameWithTrademark = (name: string) => {
  // Check if name contains ® trademark symbol
  if (name?.includes('®')) {
    // Find the position of ® and split the string
    const trademarkIndex = name.indexOf('®');
    const firstPart = name.substring(0, trademarkIndex);
    const lastPart = name.substring(trademarkIndex + 1);

    // Return JSX element with ® in sup tag between the parts
    return (
      <>
        {firstPart}
        <sup>®</sup>
        {lastPart}
      </>
    );
  }

  // Return just the string if no trademark symbol
  return name;
};
